import { Flex, Text, Toggle } from '@upsales/components';
import { useSelector, useFeatureAvailable } from 'App/components/hooks';
import { Feature } from 'App/components/hooks/featureHelper';
import { useTranslation } from 'Components/Helpers/translate';
import React, { useMemo } from 'react';
import RequestBuilder from 'Resources/RequestBuilder';
import { useProspectingCount } from './useProspectingCount';

type Props = {
	checked: boolean;
	onChange: (checked: boolean) => void;
	filters: RequestBuilder;
	totalCount: number;
};

const UnfollowProspectingToggle: React.FC<Props> = ({ checked, onChange, filters, totalCount }) => {
	const { t } = useTranslation();
	const hasProspectingBasic = useFeatureAvailable(Feature.PROSPECTING_BASIC);
	const accountVersion = useSelector(({ App }) => App.accountSelf?.version);
	const autoAddProspectingDataEnabled = useSelector(({ App }) => App.metadata?.params?.AutoAddProspectingData);

	const conditionsNotMet = useMemo(
		() => !hasProspectingBasic || autoAddProspectingDataEnabled || accountVersion?.toLowerCase() === 'accelerate',
		[hasProspectingBasic, accountVersion, autoAddProspectingDataEnabled]
	);

	const { prospectingCount, isLoading } = useProspectingCount({
		filters,
		conditionsNotMet
	});

	if (conditionsNotMet) {
		return null;
	}

	return (
		<Flex direction="column">
			<Flex alignItems="center" gap="u3">
				<Toggle checked={checked} onChange={onChange} />
				<Flex direction="column">
					<Text>{t('prospecting.unfollowToggle')}</Text>
					<Text size="sm" color="grey-12">
						{isLoading
							? t('default.loading')
							: t('prospecting.unfollowCount', { count: prospectingCount, total: totalCount })}
					</Text>
				</Flex>
			</Flex>
		</Flex>
	);
};

export default UnfollowProspectingToggle;
